import { ScrollArea } from '@/components/ui/scroll-area';
import { Music, ExternalLink } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MusicNewsSection = () => {
  const [musicNews, setMusicNews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMusicNews = async () => {
    try {
      const response = await axios.get(`${API}/news/music`);
      setMusicNews(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching music news:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMusicNews();
  }, []);

  return (
    <div className="content-card" data-testid="music-news-section">
      <div className="card-header">
        <h2>
          <Music size={20} className="inline" /> UK Music & Chart News
        </h2>
      </div>
      <ScrollArea className="card-content">
        {loading ? (
          <p className="loading-text">Loading music news...</p>
        ) : (
          <div className="news-list">
            {musicNews.length > 0 ? (
              musicNews.map((item, index) => (
                <div key={item.link || `${item.title}-${index}`} className="news-item" data-testid={`music-news-${index}`}>
                  <h3 className="news-title">{item.title}</h3>
                  {item.summary && <p className="news-summary">{item.summary}</p>}
                  {item.link && (
                    <a 
                      href={item.link} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="news-link"
                      data-testid={`music-news-link-${index}`}
                    >
                      Read more <ExternalLink size={14} />
                    </a>
                  )}
                </div>
              ))
            ) : (
              <p className="no-data">No music news available</p>
            )}
          </div>
        )}
      </ScrollArea>
    </div>
  );
};

export default MusicNewsSection;